import React from "react";
import { useNavigate } from "react-router-dom";
import XendIcon from "../../icons/xend-icon.png";
import DollarCoin from "../../icons/dollar-coin.svg";
import ProjectBg from "../../icons/project-bg2.png";
import { ReactComponent as Tick } from "../../icons/tick-star.svg";
import { formatNumber } from "../../utils/formatNumber";

export const SingleEndedProject = ({ airdrop: airdrop_ }) => {
  const navigate = useNavigate();

  const goToDetails = (joined, airdrop_id) => {
   if(joined !== true) {
    navigate(`/project-details/${airdrop_id}`);
   }
  };

  const airdrop = airdrop_?.airdrop;
  return (
    <div
      className="p-3 bg-cover bg-no-repeat rounded-[10px]"
      style={{
        backgroundImage: `url('${ProjectBg}')`,
        backgroundColor: "#000000",
        boxShadow: "0px 5px 0px 0px #CACACA40",
        opacity:0.5
      }}
      onClick={() => goToDetails(airdrop?.joined, airdrop?.airdrop_id)}
    >
      <div className="flex justify-between items-center w-full mb-4">
        <div className="flex items-center gap-2">
          <div className="relative w-fit">
            <img
              src={airdrop?.logo || XendIcon}
              alt="logo"
              className="w-[1.875rem] h-[1.875rem] rounded-[0.25rem]"
            />
            <Tick className="w-5 h-5 absolute -bottom-1 -right-2" />
          </div>

          <p className="font-semibold text-white text-[0.875rem]">
            {airdrop?.name}
          </p>
        </div>
        <button
          onClick={() => {}}
          disabled={false}
          className="bg-[#A3A9C1] h-[30px] w-[70px] text-[#434A5E] text-[0.75rem] font-semibold rounded-[30px] px-3"
        >
          <div className={`sub-button first-letter:uppercase`}>
            {airdrop?.status}
          </div>
        </button>
      </div>

      <div className="max-w-[230px] mb-4">
        <p className="font-semibold text-white text-[0.875rem]">
          {(airdrop?.description)}
        </p>
      </div>

      {/* Footer area */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div>
            <p className="text-[0.625rem] text-[#808080] mb-1">Reward pool</p>
            <div className="flex gap-1 items-center bg-black rounded-[1rem] py-1 px-2 min-h-[30px]">
              <img
                src={airdrop?.logo || XendIcon}
                alt="logo"
                className="w-[1rem] h-[1rem] rounded-[1rem]"
              />
              <span className="text-[0.625rem] text-white">
                {formatNumber(airdrop?.rewardPoolAmount ?? 0)} {airdrop?.symbol}
              </span>
            </div>
          </div>

          <div>
            <p className="text-[0.625rem] text-[#808080] mb-1">Loot per hour</p>
            <div className="flex gap-1 items-center bg-black rounded-[1rem] py-1 px-2 min-h-[30px]">
              <img
                src={DollarCoin}
                alt="coin"
                className="w-[1rem] h-[1rem] rounded-[1rem]"
              />
              <span className="text-[0.625rem] text-white">
                +{formatNumber(airdrop?.profitPerHour ?? 0)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
